import axios from "axios";
import { store } from "../index";
import { SUBMIT_FEEDBACK } from "./constant";

/**
 * Submit a customer feedback / rating.
 * Auth is intentionally optional for now — the QR feedback page is public.
 * When the auth flow lands, the session token will already be attached below.
 *
 * @param {Object} input { store_id, rating, source, order_no, order_type,
 *                          customer_name, customer_mobile, issue_category, comment }
 */
const submit_feedback = async (input) => {
  const session = store.getState().sessionReducer || {};
  const { token } = session;

  const optionAxios = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "x-api-source": "webapp",
    },
  };
  if (token) optionAxios.headers.authorization = token;

  return axios
    .post(SUBMIT_FEEDBACK, input, optionAxios)
    .then((resp) => resp.data)
    .catch((error) => {
      console.log("submit_feedback error", error);
      return { status: false, message: error?.message || "Request failed" };
    });
};

export { submit_feedback };
